<template>
<div>
	<v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="Life Map"
            :length="0"
            btn_txt=""
            btn_to="" />

        <div class="mt-6 text-center" v-if="$route.params.uid != undefined">
            <v-btn text class="accent--text" @click="$router.push('/profile/'+$route.params.uid)">Back to user profile</v-btn>
        </div>
        
        <!-- LAPSES -->
        <div class="mt-6 d-flex justify-center">
            <v-btn rounded outlined small class="mx-1" @click="setLapse(15)" :class="(actual.lapse==15) ? 'cyan white--text' : 'grey--text text--darken-2'">
                <v-icon size="12px" left>fa-check</v-icon>
                <span style="font-size:10px">15 years</span>
            </v-btn>
            <v-btn rounded outlined small class="mx-1" @click="setLapse(10)" :class="(actual.lapse==10) ? 'cyan white--text' : 'grey--text text--darken-2'" :disabled="!canYear10">
                <v-icon size="12px" left v-if="canYear10">fa-check</v-icon>
                <v-icon size="12px" left v-else>fa-lock</v-icon>
                <span style="font-size:10px">10 years</span>
            </v-btn>
            <v-btn rounded outlined small class="mx-1" @click="setLapse(5)" :class="(actual.lapse==5) ? 'cyan white--text' : 'grey--text text--darken-2'" :disabled="!canYear5">
                <v-icon size="12px" left v-if="canYear5">fa-check</v-icon>
                <v-icon size="12px" left v-else>fa-lock</v-icon>
                <span style="font-size:10px">5 years</span>
            </v-btn>
            <v-btn rounded outlined small class="mx-1" @click="setLapse(1)" :class="(actual.lapse==1) ? 'cyan white--text' : 'grey--text text--darken-2'" :disabled="!canYear1">
                <v-icon size="12px" left v-if="canYear1">fa-check</v-icon>
                <v-icon size="12px" left v-else>fa-lock</v-icon>
                <span style="font-size:10px">1 year</span>
            </v-btn>
        </div>

        <!-- MYSELF -->
        <v-card class="mx-auto bMap white--text mt-5" max-width="280px">
            <div class="pa-4 text-center body-2 font-weight-medium">Myself in {{actual.lapse}} year<span v-if="actual.lapse>1">s</span></div>
        </v-card>
        
        

        <!-- VISION -->
        <div v-if="loaded">
            <div class="text-center mt-5 mb-n1">
                <v-icon color="bMap">fa-arrow-up</v-icon>
            </div>
            <v-card class="mx-auto text-center primary white--text body-2" max-width="700px" v-if="!validateIsEmpty(goals['t'+actual.lapse].vision)">
                
                <div class="bMap" style="height:10px"></div>
                <div class="px-4 pb-4 pt-3 body-1" style="line-height:1.5">
                    {{goals['t'+actual.lapse].vision}}
                    <v-btn x-small fab absolute top right class="accent mr-n2" v-if="pencil" @click.stop="showDiagVision=true">
                        <v-icon size="11px">fa-pen</v-icon>
                    </v-btn>
                </div>
            </v-card>

            <PendingVisionCard class="mt-4" @edit="showDiagVision=true" v-if="validateIsEmpty(goals['t'+actual.lapse].vision) && user.role.student" />
        </div>

        <!-- PENCILS -->
        <div class="text-center mt-4" v-if="user.role.student">
            <v-btn rounded x-small class="accent" @click="pencil=!pencil">
                <span style="font-size:9px" v-if="pencil==false">Show edit pencils</span>
                <span style="font-size:9px" v-else>Hide pencils</span>
            </v-btn>
        </div>

        <!-- GOALS -->
        <div class="d-flex justify-space-between mt-8" v-if="$vuetify.breakpoint.smAndUp && loaded">
            <div v-for="(item, index) in modelGoals" :key="item.id">
                <div v-if="!validateIsEmpty(item.goal)">
                    <v-card 
                        width="140px" height="80px" class="d-flex align-center" hover
                        :class="(index==actual.goal) ? 'cyan' : 'primary'"
                        @click="showResources(index)">
                        <v-card-text class="text-center white--text" style="line-height:1.2">
                            <div>{{item.goal}}</div>
                            <div class="mt-1" style="opacity:.6; font-size:10px">({{item.type.toUpperCase()}})</div>
                        </v-card-text>
                        <v-btn x-small fab absolute top right class="accent mr-n2" v-if="pencil" @click.stop="getEditGoal(index)">
                            <v-icon size="11px">fa-pen</v-icon>
                        </v-btn>
                    </v-card>
                    <div class="text-center mt-4" v-if="index==actual.goal && watchResources">
                        <v-icon  color="cyan">fa-long-arrow-alt-down</v-icon>
                    </div>
                </div>

                <PendingCard text="Set a goal" @edit="getEditGoal(index)" v-if="validateIsEmpty(item.goal) && user.role.student" />
            </div>
        </div>

        <div class="cyan mt-3" style="height:2px" v-if="$vuetify.breakpoint.smAndUp && loaded && watchResources"></div>

        <!-- RESOURCES -->
        <div class="d-flex justify-center mt-8" v-if="$vuetify.breakpoint.smAndUp && loaded && watchResources">
            <!-- YES -->
            <div :class="{'mr-12': !watchActions}">
                <div class="text-center mb-4">
                    <v-chip class="white--text caption font-weight-medium" color="green lighten-1">
                        <v-icon small color="white" class="mx-2">fa-check-circle</v-icon>
                        <span class="mr-2">RESOURCES I HAVE</span>
                    </v-chip>
                </div>

                <div v-for="(item, index) in resourcesYes['g'+actual.goal]" :key="item.id">
                    <v-card 
                        width="190px"
                        class="green lighten-1 d-flex align-center mt-6 mx-auto" 
                        v-if="!validateIsEmpty(item)">
                        <v-card-text class="text-center white--text" style="line-height:1.2">
                            {{item}}
                        </v-card-text>
                        <v-btn x-small fab absolute top right class="accent mr-n4 mt-1" v-if="pencil" @click="getEditResYes(index)">
                            <v-icon size="11px">fa-pen</v-icon>
                        </v-btn>
                    </v-card>

                    <PendingCard text="Set a resource" @edit="getEditResYes(index)" class="mt-6" v-if="validateIsEmpty(item) && user.role.student" />
                </div>
            </div>

            <!-- NO -->
            <div :class="{'ml-12': !watchActions}">
                <div class="text-center">
                    <v-chip class="caption font-weight-medium black--text" color="amber">
                        <v-icon small color="black" class="mx-2">fa-exclamation-circle</v-icon>
                        <span class="mr-2">RESOURCES I NEED</span>
                    </v-chip>
                </div>

                <div v-for="(item, index) in resourcesNo['g'+actual.goal]" :key="item.id">
                    <div class="d-flex align-center" v-if="!validateIsEmpty(item)">
                        <v-card 
                            width="190px"
                            class="d-flex amber align-center mt-6 mx-auto" hover
                            @click="showActions(index)"
                            >
                            <v-card-text class="text-center black--text" style="line-height:1.2">
                                <div>{{item}}</div>
                            </v-card-text>
                            <v-btn x-small fab absolute top right class="accent mr-n4 mt-1" v-if="pencil" @click.stop="getEditResNo(index)">
                                <v-icon size="11px">fa-pen</v-icon>
                            </v-btn>
                        </v-card>
                        <div class="pt-6" v-if="!watchActions">
                            <v-icon size="18px" color="amber">fa-level-down-alt</v-icon>
                        </div>
                    </div>
                    
                    <PendingCard text="Set a resource" @edit="getEditResNo(index)" class="mt-6" v-if="validateIsEmpty(item) && user.role.student" />

                    <!-- ACTIONS -->
                    <div style="padding-left:100px" v-if="actual.resourceN==index && watchActions">
                        <div class="text-center mt-4 mb-3" v-if="actual.goal!=null">
                            <div class="text-center mb-2 mr-12">
                                <v-icon color="cyan">fa-long-arrow-alt-down</v-icon>
                            </div>
                            <div class="d-flex ml-2">
                                <v-chip class="caption font-weight-medium white--text" color="red">
                                    <v-icon small color="white" class="mx-2">fa-exclamation-circle</v-icon>
                                    <span class="mr-2">ACTIONS TO TAKE</span>
                                </v-chip>
                                <v-icon size="18px" color="red" class="ml-2" @click="showActions(index)">fa-times-circle</v-icon>
                            </div>
                        </div>
                        <div v-for="(item, index) in actions" :key="item.id">
                            <v-card 
                                width="190px" 
                                class="d-flex pink align-center mt-3 mx-auto"
                                v-if="!validateIsEmpty(item.action)">
                                <v-card-text class="text-center white--text" style="line-height:1.2">
                                    <div>{{item.action}}</div>
                                    
                                    <v-chip x-small class="font-weight-medium pink--text mt-3" color="white">
                                        <span style="font-size:10px">{{item.status.toUpperCase()}}</span>
                                    </v-chip>
                                </v-card-text>
                                <v-btn x-small fab absolute top right class="accent mr-n4 mt-1" v-if="pencil" @click="getAction(index)">
                                    <v-icon size="11px">fa-pen</v-icon>
                                </v-btn>
                            </v-card>

                            <PendingActionCard :pencil="pencil" class="mt-3" @edit="getAction(index)" v-if="validateIsEmpty(item.action) && user.role.student" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</v-card>

    <DiagVision
        :model="showDiagVision"
        :goals="goals"
        :actual="actual"
        @cancel="showDiagVision=false"
        @saved="reinitFromVision"
        v-if="showDiagVision" />

    <DiagGoal
        :model="showDiagGoal"
        :goals="goals"
        :actual="actual"
        @cancel="cancelGoal"
        @saved="reinitFromGoal"
        v-if="showDiagGoal" />
    
    <DiagResYes
        :model="showDiagResYes"
        :goals="goals"
        :actual="actual"
        @cancel="showDiagResYes=false"
        @saved="reinitFromYes"
        v-if="showDiagResYes" />
    
    <DiagResNo
        :model="showDiagResNo"
        :goals="goals"
        :actual="actual"
        @cancel="showDiagResNo=false"
        @saved="reinitFromNo"
        v-if="showDiagResNo" />

    <DiagAction
        :model="showDiagAction"
        :goals="goals"
        :actual="actual"
        @cancel="showDiagAction=false"
        @saved="reinitFromAction"
        v-if="showDiagAction" />
</div>
</template>

<script>
import Helpers from '@/services/helpers'
import Users from '@/firebase/users'
import BuildingGoals from '@/components/mapOfLife/BuildingGoals'
import PendingCard from '@/components/mapOfLife/PendingCard'
import PendingActionCard from '@/components/mapOfLife/PendingActionCard'
import PendingVisionCard from '@/components/mapOfLife/PendingVisionCard'
import DiagGoal from '@/components/mapOfLife/DiagGoal'
import DiagResYes from '@/components/mapOfLife/DiagResYes'
import DiagResNo from '@/components/mapOfLife/DiagResNo'
import DiagAction from '@/components/mapOfLife/DiagAction'
import DiagVision from '@/components/mapOfLife/DiagVision'

export default {
    data: () => ({
        loaded: false,
        goals: {
            t15: {},
            t10: {},
            t5: {},
            t3: {},
            t1: {}
        },
        modelGoals: [
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            }
        ],
        resourcesYes: {},
        resourcesNo: {},
        actions: [],
        actual: {
            lapse: null,
            goal: null,
            resourceY: null,
            resourceN: null,
            action: null
        },
        pencil: false,
        showDiagGoal: false,
        showDiagResYes: false,
        showDiagResNo: false,
        showDiagAction: false,
        showDiagVision: false,
        watchResources: false,
        watchActions: false
    }),
    components: {
        BuildingGoals,
        PendingCard,
        PendingActionCard,
        PendingVisionCard,
        DiagGoal,
        DiagResYes,
        DiagResNo,
        DiagAction,
        DiagVision
    },
    computed: {
        canYear10() {
            if (this.goals.t15.vision && this.goals.t15.goals && this.goals.t15.goals.length>=3 && this.goals.t15.resourcesYes && this.goals.t15.resourcesNo &&
                this.goals.t15.resourcesYes.g0 && this.goals.t15.resourcesYes.g1 && this.goals.t15.resourcesYes.g2 && 
                this.goals.t15.resourcesNo.g0 && this.goals.t15.resourcesNo.g1 && this.goals.t15.resourcesNo.g2)  {
                return true;
            }
            return false;
        },
        canYear5() {
            if (this.goals.t10.vision && this.goals.t10.goals && this.goals.t10.goals.length>=3 && this.goals.t10.resourcesYes && this.goals.t10.resourcesNo &&
                this.goals.t10.resourcesYes.g0 && this.goals.t10.resourcesYes.g1 && this.goals.t10.resourcesYes.g2 && 
                this.goals.t10.resourcesNo.g0 && this.goals.t10.resourcesNo.g1 && this.goals.t10.resourcesNo.g2)  {
                return true;
            }
            return false;
        },
        canYear1() {
            if (this.goals.t5.vision && this.goals.t5.goals && this.goals.t5.goals.length>=3 && this.goals.t5.resourcesYes && this.goals.t5.resourcesNo &&
                this.goals.t5.resourcesYes.g0 && this.goals.t5.resourcesYes.g1 && this.goals.t5.resourcesYes.g2 && 
                this.goals.t5.resourcesNo.g0 && this.goals.t5.resourcesNo.g1 && this.goals.t5.resourcesNo.g2)  {
                return true;
            }
            return false;
        }
    },
    mounted() {
        this.setLapse(15);
    },
    methods: {
        setLapse(year) {
            this.loaded = false;
            this.watchResources = false;
            this.actual.goal = null;
            this.clear();
            this.actual.lapse = year;
            this.init();
        },
        reinitFromVision() {
            this.showDiagVision = false;
            this.loaded = false;
            this.clear();
            this.init();
        },
        reinitFromGoal(index) {
            this.showDiagGoal = false;
            this.loaded = false;
            this.clear();
            this.actual.goal = index;
            this.init();
            this.setResource();
            this.watchResources = true;
        },
        reinitFromYes() {
            this.showDiagResYes = false;
            this.loaded = false;
            this.init();
            this.setResource();
        },
        reinitFromNo(index) {
            this.showDiagResNo = false;
            this.loaded = false;
            this.showActions(index);
            this.init();
            this.setResource();
        },
        reinitFromAction(index) {
            this.showDiagAction = false;
            this.loaded = false;
            this.init();
            this.setActions();
            // this.showActions(this.actual.resourceN);
        },
        init() {
            if ( this.$route.params.uid == undefined && (this.user.role.captain || this.user.role.master || this.user.role.director) ) {
                this.$router.push('/home');
            } else {
                this.begin(this.user);
            }

            if (this.$route.params.uid != undefined) {
                Users.get(this.$route.params.uid)
                    .then(response => {
                        let user = response.doc.data();
                        user.uid = response.doc.id;
                        this.begin(user);
                    });
            }
        },
        isOwner() {
            if (this.user.uid === this.$route.params.uid) {
                return true;
            }
            return false;
        },
        begin(us) {
            if (us.goals) {
                if (us.goals.t15)    this.goals.t15 = JSON.parse(JSON.stringify(us.goals.t15));
                if (us.goals.t10)    this.goals.t10 = JSON.parse(JSON.stringify(us.goals.t10));
                if (us.goals.t5)    this.goals.t5 = JSON.parse(JSON.stringify(us.goals.t5));
                if (us.goals.t3)    this.goals.t3 = JSON.parse(JSON.stringify(us.goals.t3));
                if (us.goals.t1)    this.goals.t1 = JSON.parse(JSON.stringify(us.goals.t1));
            }

            this.setGoal();
            this.loaded = true;
        },
        // GOALS ----------------------------------------------------------------------------
        setGoal() { 
            let lapse = this.actual.lapse;

            this.modelGoals = [
                { goal: '',type: 'professional'},
                { goal: '',type: 'professional'},
                { goal: '',type: 'professional'},
                { goal: '',type: 'professional'},
                { goal: '',type: 'professional'},
                { goal: '',type: 'professional'},
            ]

            if (this.goals['t'+lapse].goals) {
                _.merge(this.modelGoals, this.goals['t'+lapse].goals);
            } 
        },
        getEditGoal(index) {
            this.actual.goal = index;
            this.showDiagGoal = true;
            this.watchResources = false;
        },
        cancelGoal() {
            this.clear();
            this.showDiagGoal = false;
        },
        clear() {
            this.actual.resourceY = null;
            this.actual.resourceN = null;
            this.actual.action = null;
        },
        // RESOURCES ----------------------------------------------------------------------------
        showResources(index) {
            this.clear();
            this.watchActions = false;

            if (index != this.actual.goal) {
                this.actual.goal = index;
                this.setResource();
                this.watchResources = true;
            } else {
                this.actual.goal = null;
                this.watchResources = false;
            }
        },
        getEditResYes(index) {
            this.actual.resourceY = index;
            this.showDiagResYes = true;
        },
        getEditResNo(index) {
            this.actual.resourceN = index;
            this.showDiagResNo = true;
        },
        setResource() {
            let lapse = this.actual.lapse;
            let goal = this.actual.goal;

            this.resourcesYes['g'+goal] = ['', '', '', '', ''];
            this.resourcesNo['g'+goal] = ['', '', ''];

            if (this.goals['t'+lapse].resourcesYes && this.goals['t'+lapse].resourcesYes['g'+goal]) {
                _.merge(this.resourcesYes['g'+goal], this.goals['t'+lapse].resourcesYes['g'+goal]);
            }

            if (this.goals['t'+lapse].resourcesNo && this.goals['t'+lapse].resourcesNo['g'+goal]) {
                _.merge(this.resourcesNo['g'+goal], this.goals['t'+lapse].resourcesNo['g'+goal]);
            }
        },
        // ACTIONS ----------------------------------------------------------------------------
        showActions(index) {
            if (index != this.actual.resourceN) {
                this.actual.resourceN = index;
                this.setActions();
                this.watchActions = true;
            } else {
                this.actual.resourceN = null;
                this.watchActions = false;
            }
        },
        setActions() {
            let i;
            let lapse = this.actual.lapse;
            let goal = this.actual.goal;
            let resourceN = this.actual.resourceN;
            
            for (i=0; i<=4; i++) {
                this.actions[i] = {action:'', status:'todo'};
            }

            if (this.goals['t'+lapse].actions && this.goals['t'+lapse].actions['g'+goal+'_'+resourceN] != undefined) {
                _.merge(this.actions, this.goals['t'+lapse].actions['g'+goal+'_'+resourceN]);
            } 
            
        },
        getAction(index) {
            this.actual.action = index;
            this.showDiagAction = true;
        },
        // INITIAL GOALS ----------------------------------------------------------------------------
        setInitialGoals() {
            this.loaded = false;

            Personal.updateGoals(this.user.uid, this.goals)
                    .then(response => {
                        if (response === true) {
                            this.$store.dispatch('setGoals', this.goals);
                            Sign.reInitUser(this.user.uid);
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                    });
        }
    }
}
</script>

